/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 05.03.15.
 */

angular
  .module('farmnet.partner.fendt')
  .directive('fendtVarioDocButton', function() {
    'use strict';

    return {
      restrict: 'E',
      scope: {
        machine: '=',
        state: '='
      },
      templateUrl: require('./FendtVarioDocButtonView.html'),
      controller: 'FendtVarioDocButtonController'
    };
  });
